import * as ngCore from '@angular/core'

import * as state from '../../../../../../../../../../state'

import * as column from './column'
import * as row from './row'
import * as widget from './widget'

/**
 * This component is designed to be recursive, meaning it can contain
 * {@link column.Component} or {@link row.Component}, which also can have
 * instances of this component.
 *
 * To handle recursion and avoid circular dependency issues, we use `forwardRef`
 * to reference {@link column.Component} and {@link row.Component} when
 * importing them. Circular dependencies occur when two components reference
 * each other, causing Angular to be unable to resolve them at the time of
 * module loading.
 *
 * Using `forwardRef` allows Angular to defer the resolution of the
 * {@link column.Component} and {@link row.Component} reference until the
 * runtime, thus breaking the circular dependency chain.
 *
 * @see https://angular.io/api/core/forwardRef for more details on forwardRef
 * usage.
 */
@ngCore.Component({
  imports: [
    widget.Component,
    ngCore.forwardRef(() => column.Component),
    ngCore.forwardRef(() => row.Component),
  ],
  selector: 'atn-mosaic-grid-element',
  standalone: true,
  styleUrl: './component.scss',
  templateUrl: './component.html',
})
export class Component {
  /**
   * @see {@link state.mosaic.endUser.currentRendering.models.page.Content.Element}
   */
  public readonly elementSg =
    ngCore.input.required<state.mosaic.endUser.currentRendering.models.page.Content.Element>(
      {
        alias: 'element',
      },
    )
}
